import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { TestId } from '@repo/test-id';
import { useUser } from '@repo/domain-service';

import AuthBanner from '@features/account/components/AuthBanner';
import SignOutSection from '@features/account/components/SignOutSection';
import Header from '@features/account/components/Header';
import ProfileCard from '@features/account/components/ProfileCard';
import { selectStatus, selectNeedsAuthOrConsent, useAuthStore, AuthModal } from '@features/auth';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function AccountLayout() {
  const testId = TestId.root('accountLayout');
  const navigate = useNavigate();
  const { user } = useUser();
  const needsAuthOrConsent = useAuthStore(selectNeedsAuthOrConsent);
  const isLoggedIn = useAuthStore(selectStatus) === 'authenticated';
  const [showAuth, setShowAuth] = useState<boolean>(false);

  const handleLoginClick = () => setShowAuth(true);

  const handleRegisterClick = () => setShowAuth(true);

  const handleDismissal = () => setShowAuth(false);

  const handleEditProfile = () => navigate(ROUTE_PATHS[RouteName.ACCOUNT_EDIT]);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          <Header testId={testId.append('header')} />
          {isLoggedIn && user && (
            <ProfileCard
              name={user.name}
              email={user.email}
              onEdit={handleEditProfile}
              testId={testId.append('profileCard')}
            />
          )}

          <Outlet />

          {isLoggedIn && <SignOutSection testId={testId.append('signOut')} />}
        </div>

        {!isLoggedIn && !user && (
          <AuthBanner
            onLogin={handleLoginClick}
            onRegister={handleRegisterClick}
            testId={testId.append('authBanner')}
          />
        )}
      </div>

      {showAuth && needsAuthOrConsent && <AuthModal onOpenChange={handleDismissal} />}
    </div>
  );
}
